import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { NewPageHeaderStyled } from "./styled";

const NewPageHeader = ({ theme_standard, title, sub_title }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return <NewPageHeaderStyled className={customClass}>
    <div className="title">{title}</div>
    <div className="liner" />
    <div className="sub_title">{sub_title}</div>
  </NewPageHeaderStyled>;
};

NewPageHeader.propTypes = {};

export default NewPageHeader;
